<ul class="kt-sticky-toolbar {{expanded ? 'expanded': ''}}">
  <li class="support" (click)="expand()"> {{ 'SUPPORT.TITLE' | translate }} </li>
  <hr class="vertical-line">
  <span class="position-absolute expanded-section ml-2">
    <a href="javascript:" (click)="openLiveChat()">
      <i class="fas fa-comment"></i>&nbsp; {{ 'SUPPORT.LIVE_CHAT' | translate }}
      <span class="unread-dot" *ngIf="(supportChat.unreadCount$ | async) > 0"></span>
    </a>
    <a href="javascript:"> <i class="fas fa-envelope"></i>&nbsp; {{ 'SUPPORT.MESSAGE' | translate }} </a>
    <a href="javascript:"> <i class="fas fa-question-circle"></i>&nbsp; {{ 'SUPPORT.HELP' | translate }} </a>
  </span>
</ul>
